import React from 'react';
import { Box, Tooltip } from '@mui/material';
import InfoIcon from "assets/images/info.svg";

function CommonLabelInfo(props) {
  return (
    <div>
      <Tooltip title={props?.title} arrow>
        <Box className="pl10 justifyCenter">
          <img src={InfoIcon} alt="InfoIcon" />
        </Box>
      </Tooltip>
    </div>
  );
}

export default CommonLabelInfo;
